import React from "react";
import Select from "react-select";
import InputText from "../../../common/Input/InputText";
import styles from "../editLabReport.module.scss";

const dropdownConfig = {
  Color: ["Yellowish", "Brownish", "Greenish"],
  Consistency: ["Solid", "Semi Solid", "Liquid", "Semi Liquid"],
  Mucus: ["Present", "Absent"],
  Reaction: ["Acidic", "Alkaline"],
  "Vegetable Cell": ["Nil", "Present(+)", "Present(++)"],
  Ova: ["Round Worm", "Hook Worm", "Not Found"],
  Larva: ["Round Worm", "Hook Worm", "Not Found"],
  "Fat Globles": ["Nil", "Present(+)", "Present(++)"],
};

const sectionConfig = {
  MACROSCOPIC: ["Color", "Consistency", "Mucus", "Reaction"],
  MICROSCOPIC: [
    "Vegetable Cell",
    "Bacteria",
    "Pus Cell",
    "RBC",
    "Ova",
    "Larva",
    "Trophozoite",
    "Fat Globles",
    "Others",
  ],
};

const StoolRMProfile = ({ profile, testMap, handleTestProfileChange }) => {
  const renderField = (item, index) => {
    const testData = testMap.get(item._id) || {};
    const testName = item?.testName;

    const options = dropdownConfig[testName];
    const isDropdown = !!options;

    return (
      <div className={styles.testAndProfileWrapper} key={index}>
        <div className={styles["inputWrapper"]}>
          <div className="form-group">
            <InputText
              value={testName}
              label="Test Name"
              readOnly={true}
            />
          </div>
        </div>

        <div className={styles["inputWrapper"]}>
          <div className="form-group">
            {isDropdown ? (
              <>
                <label className="col-form-label">Value:</label>
                <Select
                  placeholder="Select Value"
                  value={
                    testData.value
                      ? { label: testData.value, value: testData.value }
                      : null
                  }
                  onChange={(e) =>
                    handleTestProfileChange(
                      e,
                      "value",
                      profile._id,
                      item._id
                    )
                  }
                  options={options.map((opt) => ({
                    label: opt,
                    value: opt,
                  }))}
                />
              </>
            ) : (
              <InputText
                value={testData.value || ""}
                onChange={(e) =>
                  handleTestProfileChange(
                    e,
                    "value",
                    profile._id,
                    item._id
                  )
                }
                label="Value"
              />
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {Object.keys(sectionConfig).map((section) => {
        const sectionTests = profile?.tests?.filter((test) =>
          sectionConfig[section].includes(test.testName)
        );

        if (!sectionTests?.length) return null;

        return (
          <div key={section}>
            <h4 style={{ marginTop: "20px", fontWeight: "600" }}>
              {section}
            </h4>

            {sectionTests.map((item, index) =>
              renderField(item, index)
            )}
          </div>
        );
      })}
    </>
  );
};

export default StoolRMProfile;